import { z } from "../wire/zod";

export const createCategoryResponseSchema = z.object({ id: z.string() });
export const createFlexboardResponseSchema = z.object({ id: z.string() });
export const createFlexboardTypeResponseSchema = z.object({ id: z.string() });
export const deleteFlexboardTypeResponseSchema = z.object({
  success: z.boolean(),
  boards: z.array(z.string()).optional(),
});
export const getBackgroundsResponseSchema = z.object({
  backgrounds: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      defaultStickyTypes: z.array(z.object({ name: z.string(), color: z.string() })),
    }),
  ),
});
export const getCategoriesResponseSchema = z.object({
  categories: z.array(
    z
      .object({
        id: z.string(),
        sessionId: z.string().optional(),
        name: z.string(),
        position: z.number().int().optional(),
        boardIds: z.array(z.string()),
      })
      .describe(
        "Embedded list item of the per-session categories document; carries no session_id or position",
      ),
  ),
});
export const getFlexboardTypesResponseSchema = z.object({
  types: z.array(
    z.object({ id: z.string(), sessionId: z.string(), name: z.string(), background: z.string() }),
  ),
});
export const noDataSchema = z.record(z.string(), z.never());
